import Intro from './component'
export default Intro
